import { getUtagData, getUtagDataChatConfig } from './utag-data';

export const isLoggedInUser = () => {
  // General logged in checking
  const isLoggedIn = (getUtagData().vendor_genesys_authenticate ?? '').endsWith(
    '_auth',
  );

  // hsbcnet channel only for logged in user
  const isHSBCNetChannel = getUtagDataChatConfig().channel === 'hsbcnet';

  return isLoggedIn || isHSBCNetChannel;
};
